import ArticlePage from "@/pages/article/ArticlePage";
import { allArticles } from "@/mocks/articles";

export default function ShippingArticle() {
  return <ArticlePage article={allArticles["allchinabuy-spreadsheet-shipping"]} />;
}